var render = function render(_c,_vm){return _c('div',{staticClass:"module__row module__row_scrolled"},[_c('div',{staticClass:"module__scroll module__scroll_scroll-bar"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }